<template>
  <tr :class="{ 'event-row-clickable': !reorderMode, 'reorder-row': reorderMode }"
      @click="!reorderMode ? $emit('toggle-expand', config.eventId) : null">

    <td v-if="reorderMode" style="width: 34px;" @click.stop>
      <span class="drag-handle" title="Drag to reorder">⋮⋮</span>
    </td>

    <td class="col-1 text-truncate" :class="eventStateClass">
      {{ truncatedEventId }}
    </td>
    <td class="col-1 text-truncate">{{ truncatedFirstMatcher }}</td>
    <td class="col-1 text-truncate">{{ truncatedSecondMatcher }}</td>
    <td class="col-1 text-truncate">{{ truncatedLeague }}</td>
    <td class="col-1 text-truncate">{{ truncatedLeagueId }}</td>
    <td class="col-1 text-truncate">{{ truncatedOrderNumber }}</td>
    <td class="col-1 text-truncate">{{ truncatedApplication }}</td>
    <td class="col-1 text-truncate">{{ truncatedStatus }}</td>
    <td class="col-1 text-truncate">{{ truncatedActive }}</td>

    <td
        class="col-2 centered cell-action"
        :class="{ 'is-disabled': hasRunning || reorderMode }"
        role="link"
        tabindex="0"
        @click="goToBroadcast(config)"
        @keydown.enter.prevent="goToBroadcast(config)"
        @keydown.space.prevent="goToBroadcast(config)"
    >
      <div class="cell-action-title">
        Configure Channels and Streams
      </div>

      <div v-if="hasRunning" class="channel-mismatch-text">
        Disabled editing when active
      </div>
    </td>

    <td class="col-1 centered">
      <button v-if="hasRunning" class="procricket-btn-stop btn-xs danger" :disabled="reorderMode"
          @click.stop="!reorderMode ? $emit('stop-all', config.eventId) : null" title="Stop stream" >
        Stop
      </button>
      <button v-else class="procricket-btn-start btn-xs" :disabled="reorderMode || !canStart" :title="reorderMode ? '' : startDisabledTitle"
          @click.stop="!reorderMode ? $emit('start-all', config.eventId) : null" >
        Start
      </button>
    </td>

    <td class="col-2 centered">
      <router-link @click.stop :to="{ name: 'EventEdit', params: { id: config.eventId, ...config } }" class="procricket-btn" :disabled="reorderMode">
        Edit Event
      </router-link>
    </td>
  </tr>
</template>

<script>
import { truncateText } from "@/utils/general-functions";

export default {
  name: 'EventTableRow',
  props: {
    config: {
      type: Object,
      required: true
    },
    reorderMode: {
      type: Boolean,
      default: false
    },
    eventStateClass: {
      type: String,
      default: ''
    },
    hasRunning: {
      type: Boolean,
      default: false
    },
    canStart: {
      type: Boolean,
      default: false
    },
    startDisabledTitle: {
      type: String,
      default: ''
    }
  },
  emits: ['toggle-expand', 'stop-all', 'start-all'],
  computed: {
    truncatedEventId() {
      return truncateText(this.config.eventId, 30);
    },
    truncatedFirstMatcher() {
      return truncateText(this.config.firstMatcher, 30);
    },
    truncatedSecondMatcher() {
      return truncateText(this.config.secondMatcher, 30);
    },
    truncatedLeague() {
      return truncateText(this.config.league, 30);
    },
    truncatedLeagueId() {
      return truncateText(this.config.leagueId, 30);
    },
    truncatedOrderNumber() {
      return truncateText(this.config.orderNumber, 30);
    },
    truncatedApplication() {
      return truncateText(this.config.application, 30);
    },
    truncatedStatus() {
      return truncateText(this.config.status, 30);
    },
    truncatedActive() {
      return truncateText(this.config.active, 30);
    }
  },
  methods: {
    goToBroadcast(config) {
      if (this.hasRunning || this.reorderMode) return;

      // same route you had before
      this.$router.push({
        name: "EventBroadcast",
        params: { id: config.eventId, ...config }
      });
    }
  }
}
</script>